import ConceptoLiquidacion from "../domain/ConceptoLiquidacion"
import ApiServiceAdapter from "../infraestructure/ApiServiceAdapter"

class ConceptoLiquidacionService {
  constructor() {
    this.apiService = new ApiServiceAdapter()
  }

  async getConceptos() {

    const conceptoData = await this.apiService.fetchConceptos()

    const listadoConceptos = conceptoData && 
    conceptoData.map((concepto) => new ConceptoLiquidacion(
      concepto.idConcepto,
      concepto.descripcion,
      ))

      return listadoConceptos

  }
}

export default ConceptoLiquidacionService
